import {Component, OnInit} from '@angular/core';
import {MessagesService} from '../../services/messages.service';
import {Message} from 'primeng/api';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {

  notifications: Message[] = [];

  constructor(private messagesService: MessagesService) {
  }

  ngOnInit() {
    this.messagesService.message.subscribe(coiMessage => {
      if (coiMessage && coiMessage.message) {
        this.notifications = [{severity: coiMessage.type, summary: coiMessage.message}];
      } else {
        this.notifications = [];
      }
    });
  }
}
